import { sort } from 'app/utils/array';
import { mapProperties } from 'app/utils/entities/match_data';
import DrakeChemtechIcon from 'app/icons/lol_drake_chemtech.svg';
import DrakeCloudIcon from 'app/icons/lol_drake_cloud.svg';
import DrakeElderIcon from 'app/icons/lol_drake_elder.svg';
import DrakeHextechIcon from 'app/icons/lol_drake_hextech.svg';
import DrakeInfernalIcon from 'app/icons/lol_drake_infernal.svg';
import DrakeMountainIcon from 'app/icons/lol_drake_mountain.svg';
import DrakeOceanIcon from 'app/icons/lol_drake_ocean.svg';
import InhibitorsIcon from 'app/icons/lol_inhibitor.svg';
import NashorsIcon from 'app/icons/lol_nashor.svg';
import HeraldsIcon from 'app/icons/lol_herald.svg';
import TowersIcon from 'app/icons/lol_tower.svg';
import DrakesIcon from 'app/icons/lol_drake.svg';
import { round } from 'app/utils/number';
import GoldIcon from 'app/icons/lol_gold.svg';

const lolDrakeIcon: Record<LolDrakeType, SVG | null> = {
  chemtech: DrakeChemtechIcon,
  cloud: DrakeCloudIcon,
  elder: DrakeElderIcon,
  hextech: DrakeHextechIcon,
  infernal: DrakeInfernalIcon,
  mountain: DrakeMountainIcon,
  ocean: DrakeOceanIcon,
  unknown: null
};

const getLolTeamMatchStats = (
  opponent1: GameOpponentLol | undefined,
  opponent2: GameOpponentLol | undefined
): {
  opponent1MatchStats: StatData<GameOpponentLol>[];
  opponent2MatchStats: StatData<GameOpponentLol>[];
} => {
  const properties: StatProperties<GameOpponentLol>[] = [
    {
      name: 'gold',
      Icon: GoldIcon,
      displayFunction: (value: number) => `${round(value / 1000, 2)}k`
    },
    { name: 'inhibitors', Icon: InhibitorsIcon },
    { name: 'nashors', Icon: NashorsIcon },
    { name: 'heralds', Icon: HeraldsIcon },
    { name: 'towers', Icon: TowersIcon },
    {
      name: 'drakes',
      Icon: DrakesIcon,
      displayFunction: (value: LolDrake[]) => value.length.toString()
    }
  ];

  return {
    opponent1MatchStats: mapProperties(properties, opponent1),
    opponent2MatchStats: mapProperties(properties, opponent2)
  };
};

const getSortedDrakes = (
  blue: GameOpponentLol | undefined,
  red: GameOpponentLol | undefined
): (LolDrake & { side: SideLol })[] => {
  const blueDrakes: (LolDrake & { side: SideLol })[] =
    blue?.drakes.map(drake => ({
      ...drake,
      side: 'blue'
    })) ?? [];
  const redDrakes: (LolDrake & { side: SideLol })[] =
    red?.drakes.map(drake => ({
      ...drake,
      side: 'red'
    })) ?? [];

  const drakesTimetable = sort([...blueDrakes, ...redDrakes], drake => drake.timer).filter(
    drake => drake.timer !== 0
  );

  return drakesTimetable;
};

const getXAxisPosition = (chartData: number[]): number => {
  if (!chartData.length) {
    return 50;
  }
  const max = Math.max(...chartData);
  const min = Math.min(...chartData);
  return (-min / (max - min)) * 100;
};

export { getSortedDrakes, lolDrakeIcon, getLolTeamMatchStats, getXAxisPosition };
